//引入axios
import Vue from 'vue'
import axios from 'axios'
import router from '../router';
import { MessageBox } from 'element-ui';
import store from "../vuex/store";
import {originconfig} from "../../static/apiConfig/originConfig";

const domain = originconfig.domain;

Vue.prototype.__cancels__ = [];
// let cancel;
const CancelToken = axios.CancelToken;

//请求拦截器
axios.interceptors.request.use(config => {
  //发起请求时，取消掉当前正在进行的相同请求
  // 全局添加cancelToken
  config.cancelToken = new CancelToken((c) => {
    Vue.prototype.__cancels__.push(c);
  });
  return config;
}, error => {
  return Promise.reject(error)
})

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
  const errorCode = response.data.errorCode;
  if (errorCode !== 0) {
    // 某个请求的响应满足特定条件的情况下，取消其他正在进行的请求
    Vue.prototype.__cancels__.forEach((cancel) => {
      cancel();
    });
    Vue.prototype.__cancels__ = [];
  }
  return Promise.resolve(response);
}, err => {
  // if (axios.isCancel(err)) { // 取消请求的情况下，终端Promise调用链
  //   return new Promise(() => {});
  // } else {
  //   return Promise.reject(err.response);
  // }
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '错误请求'
        break;
      case 401:
        err.message = '未授权，请重新登录'
        break;
      case 403:
        err.message = '拒绝访问'
        break;
      case 404:
        err.message = '请求错误,未找到该资源'
        break;
      case 405:
        err.message = '请求方法未允许'
        break;
      case 408:
        err.message = '请求超时'
        break;
      case 500:
        err.message = '服务器端出错'
        break;
      case 501:
        err.message = '网络未实现'
        break;
      case 502:
        err.message = '网络错误'
        break;
      case 503:
        err.message = '服务不可用'
        break;
      case 504:
        err.message = '网络超时'
        break;
      case 505:
        err.message = 'http版本不支持该请求'
        break;
      default:
        err.message = `连接错误${err.response.status}`
    }
  } else {
    err.message = "连接到服务器失败"
  }
  return Promise.resolve(err.response)
})

// axios.defaults.baseURL = '/api'
//设置默认请求头
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest'
}
axios.defaults.timeout = 20000

// 封装数据返回成功提示函数---------------------------------------------------------------------------
function successState (resolve,response, callbackOnFailure) {
  // 隐藏loading
  store.commit('endLoading');
  // 统一判断后端返回的错误码(错误码与后台协商而定)
  if (response && (response.status === 200 || response.status === 304)) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    if(response.data.errorCode == 0){
      // return response.data;
      resolve(response.data)
    }else if(response.data.errorCode !== -103){
      MessageBox(response.data.message ? response.data.message : response.data.message,'提示',{
        center:true
      }).then(()=>{
        return false
      })
    }else if(callbackOnFailure != null && callbackOnFailure instanceof Function){
      callbackOnFailure(response.data);
    }else {
      MessageBox('您的登陆信息已超时，请重新登录！', '提示', {
        center: true
      }).then(() => {
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('pushInfoList');
        router.push({name: 'login'});
      })
    }
    // return response
  }else {
    console.log(response)
  }
}

  //get请求
export function get (url,param,callbackOnFailure) {
    return new Promise((resolve,reject) => {
      axios({
        method: 'get',
        url:domain + url,
        params: param,
      }).then(res => {
        successState(resolve,res,callbackOnFailure);
      })
    })
  }
  //post请求
export function post (url,param,callbackOnFailure) {
    return new Promise((resolve,reject) => {
      axios({
        method: 'post',
        url:domain + url,
        data: param,
      }).then(res => {
        successState(resolve,res,callbackOnFailure);
      })
    })
  }
export function login (url,param) {
  return new Promise((resolve,reject) => {
    axios({
      method: 'post',
      url:domain + url,
      data: param,
    }).then(res => {
      if(res.status === 200 || res.status === 304){
        resolve(res.data)
        // if(res.data && res.data.errorCode == 0){
        //   sessionStorage.setItem('currentUser', JSON.stringify(res.data.data));
        //   this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        //   router.push({name: 'statisticalInfoMain'});
        // }else if(res.data.errorCode == -114){
        //   MessageBox(res.data.msg ? res.data.msg : res.data.message,'提示',{
        //     center:true
        //   }).then(()=>{
        //     return false
        //   })
        // }
      }
    })
  })
}
export function logout (url,param) {
  return new Promise((resolve,reject) => {
    axios({
      method: 'post',
      url:domain + url,
      params: param,
    }).then(res => {
      router.push({name: 'login'});
      resolve(res.data)
    })
  })
}
export function getBreath(url,param) {
  return new Promise((resolve,reject) => {
    axios({
      method: 'post',
      url:domain + url,
      params: param,
    }).then(res => {
      resolve(res.data.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/service/service.js